import React, { useState, useRef } from 'react'
import parse from 'html-react-parser'
import * as E from '../elementor'
import Accordion from '../components/content/accordion'
import { TabType } from '../custom-types'

interface Props {
  section?: E.Section
  accordions?: TabType[]
  formatAsHTML?: boolean
}

const ValueProps: React.FC<Props> = ({ section }) => {
  const { textEditor = [], heading = [], accordion = [], basicGallery = [] } = (section != null) ? E.collect(section) : {}
  const accordionRefs = useRef<any[]>([])

  const [tabs, setTabs] = useState(
    accordion[0].items.map((item, idx) => {
      const content = parse(item.content || '')

      return {
        title: item.title,
        details: content,
        isActive: idx === 0
      } as TabType
    })
  )

  const handleOpened = (title: string) => {
    setTabs(
      tabs.map(i => {
        i.isActive = i.title === title
        return i
      })
    )
  }

  return (
    <section>
      <div className='value-props'>
        <h2 className='subheading'>
          {parse(textEditor[0]?.text() || '')}
        </h2>
        <h3 className='heading'>
          {parse(heading[0]?.title || '')}
        </h3>
        <div className='value-props-content'>
          <div className='img-placeholder'>
            {tabs.map((tab, idx) => (
              <img src={basicGallery[0].images[idx % basicGallery[0].images.length].fileUrl} className={tab.isActive ? 'active' : undefined} />
            ))}
          </div>
          <div className='accordion-wrapper'>
            <Accordion
              content={tabs}
              onOpened={handleOpened}
              itemRefs={accordionRefs}
              formatAsHTML
              autoOpenFirst
              enforceSingle
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ValueProps
